import { handlePromise } from "../apiControllers/helpers";
import Env from "../../Environments";
import { BEFE_KEYS, apiUrls } from "../../constants/apiUrls";

export const getPageConfig = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getBefeBaseUrl() + BEFE_KEYS.productCatalog,
  };

  return handlePromise(apiPayload);
};

export const getProductListing = async (payload) => {
  const apiPayload = {
    method: "POST",
    data: payload,
    url: Env.getTeamCommonUrl() + apiUrls.getCatalogProductListing,
  };

  return handlePromise(apiPayload);
};

export const getScmCircles = async () => {
  const apiPayload = {
    method: "GET",
    url: Env.getTeamCommonUrl() + apiUrls.getAllScmCirles,
  };

  return handlePromise(apiPayload);
};

export const updateProductDetails = async (payload) => {
  const apiPayload = {
    method: "POST",
    data: payload,
    url: Env.getTeamCommonUrl() + apiUrls.updateCatalogProduct,
  };
   return handlePromise(apiPayload);
}
